/**
 * @mergeTarget
 * @module Src/Parameters
 */
import { LisioProfilErrorCodes } from "../profil-error-codes.js";
import { LisioBooleanParameterNames, LisioBooleanParameter, } from "./lisio-boolean-parameter.js";
import { LisioNumericParameterNames, LisioNumericParameter, } from "./lisio-numeric-parameter.js";
import { LisioStringParameterNames, LisioStringParameter, } from "./lisio-string-parameter.js";
/**
 * Class representing a parameter factory.\
 * It aims to centralize all instanciation of parameters.\
 * To execute his responsability this class does :
 *  * Build a parameter with right corresponding value
 */
class LisioParameterFactory {
    /**
     * @static
     * Private attribute to store instance of {@link LisioParameterFactory | LisioParameterFactory}
     * @source
     */
    static _current;
    /**
     * @static
     * Getter for attribute {@link _current | _current}
     * @returns Returns _current attribute
     * @source
     */
    static get current() {
        return LisioParameterFactory._current;
    }
    /**
     * Private method to build a boolean parameter
     * @returns Returns a boolean parameter
     * @source
     */
    buildLisioBooleanParameter(parameterName, value) {
        return new LisioBooleanParameter(parameterName, value);
    }
    /**
     * Private method to build a numeric parameter
     * @returns Returns a numeric parameter
     * @source
     */
    buildLisioNumberParameter(parameterName, value) {
        return new LisioNumericParameter(parameterName, value);
    }
    /**
     * Private method to build a string parameter
     * @returns Returns a string parameter
     * @source
     */
    buildLisioStringParameter(parameterName, value) {
        return new LisioStringParameter(parameterName, value);
    }
    /**
     * Public method to build parameters
     * @param {LisioParameterNames} parameterName - Paramater name
     * @param {string | number | boolean} value - Value of parameter
     * @throws If parameter doesn't exist or value not corresponding.\
     * See {@link Src/Utils.LisioProfilErrorCodes.WRONG_PARAMETER | LisioProfilErrorCodes.WRONG_PARAMETER}
     * @returns Returns desired parameter
     * @source
     */
    buildLisioParameter(parameterName, value) {
        if (parameterName.toUpperCase() in LisioBooleanParameterNames &&
            typeof value === "boolean") {
            return this.buildLisioBooleanParameter(parameterName, value);
        }
        else if (parameterName.toUpperCase() in LisioNumericParameterNames &&
            typeof value === "number") {
            return this.buildLisioNumberParameter(parameterName, value);
        }
        else if (parameterName.toUpperCase() in LisioStringParameterNames &&
            typeof value === "string") {
            return this.buildLisioStringParameter(parameterName, value);
        }
        else {
            throw new Error(`Code : ${LisioProfilErrorCodes.WRONG_PARAMETER}. Parameter ${parameterName} may not exists or value ${value} not corresponding`);
        }
    }
    /**
     * Constructor of class {@link LisioParameterFactory | LisioParameterFactory}
     * @throws If singleton already initialize.\
     * See {@link https://env-preprod-docs.lisio.fr/lisio-engine/enums/Src_Core.CoreErrorCodes.html#SINGLETON_NOT_UNIQUE | CoreErrorCodes.SINGLETON_NOT_UNIQUE}
     * @source
     */
    constructor() {
        if (LisioParameterFactory._current == undefined) {
            LisioParameterFactory._current = this;
        }
        else {
            throw new Error(`Code : LisioCore_0. Singleton already initialize`);
        }
    }
}
export { LisioParameterFactory };
